import partnersIcon from 'images/icons/partners.svg';
import productIcon from 'images/icons/product.svg';
import roadmapIcon from 'images/icons/roadmap.svg';
import investorsIcon from 'images/icons/investors.svg';
import socialsIcon from 'images/icons/socials.svg';
import { screens } from 'components/sections/constants';

export const section_links = {
  [screens.PARTNERS]: [partnersIcon, "Partners"],
  [screens.INVESTORS]: [investorsIcon, "Investors"],
  [screens.PRODUCT]: [productIcon, "Product"],
  [screens.ROADMAP]: [roadmapIcon, "Roadmap"],
  [screens.SOCIAL]: [socialsIcon, "Socials"]
};